import $ from 'jquery'
import initPdfButtons from '../js/utils/init-pdf-buttons'

$(document).on('click', '.bhub-event-detail', function (e) {
  e.preventDefault()
  const post_id = $(this).attr('data-id')
  $.confirm({
    theme: 'bhub-drawer',
    closeIcon: true,
    draggable: false,
    backgroundDismiss: true,
    escapeKey: true,
    animateFromElement: false,
    animationSpeed: 300,
    animation: 'right',
    closeAnimation: 'right',
    useBootstrap: false,
    buttons: false,
    scrollToPreviousElement: false,
    onContentReady: function () {
      initPdfButtons($('.bhub-invoice')[0])
      this.$body.closest('.jconfirm').find('.jconfirm-buttons').remove()

      // Copy shortcode
      $(document).on('click', '.bhub-copy-shortcode', function () {
        let inputElement = $(this).prev('input')
        let parent = $(this).attr('data-parent')
        if (parent) {
          inputElement = $(this).closest(`.${parent}`).find('input')
        }

        inputElement.select()
        document.execCommand('copy')

        const icon = $(this).find('i')
        const currentClass = icon.attr('class')
        icon.attr('class', 'bhub-icons-check')
        setTimeout(() => {
          icon.attr('class', currentClass)
        }, 2000)
      })
    },
    content: function () {
      var self = this
      return $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          action: 'bhub/templates/modal',
          template: 'event_detail',
          post_id: post_id,
          _ajax_nonce: bookingHub.nonce,
        },
      })
        .done(function (response) {
          self.setTitle(response.title)
          self.setContent(response.content)
        })
        .fail(function () {
          self.setContent(bookingHub.i18n.basic_error)
        })
    },
  })
})

$(document).on(
  'click',
  [
    '.post-type-bhub_booking',
    '.post-type-bhub_booking_form',
    '.post-type-bhub_coupon',
    '.taxonomy-bhub_service_category',
    '.taxonomy-bhub_product_feature',
    '.taxonomy-bhub_location',
    '.taxonomy-bhub_service',
  ]
    .map((sel) => `${sel} a.row-title`)
    .join(', '),
  function (e) {
    e.preventDefault()
  }
)
